import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ApplicationLogo } from 'components/Logo/ApplicationLogo/ApplicationLogo';

export function OrderFormDialog({ heading, children }: { heading?: ReactNode; children: ReactNode }) {
  const { t } = useTranslation();

  return (
    <div className="flex w-[480px] flex-col overflow-hidden rounded-lg shadow-sm">
      <div className="bg-white p-10">
        {heading}
        {children}
      </div>
      <div className="flex items-center justify-center gap-3 bg-gray-100 p-6">
        <ApplicationLogo variant="dark" withText={false} className="h-4" />
        <span className="text-xs leading-4">
          {t('common:poweredBy')} {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            href="https://procuros.io/"
            target="_blank"
            className="font-semibold text-gray-700 hover:text-procuros-green-400"
          >
            Procuros
          </a>
        </span>
      </div>
    </div>
  );
}
